import React, { useState, useRef, useEffect } from 'react';

import style from './style.module.scss';
import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';
import sectionStyle from 'aplazame-design-system/src/scss/section.module.scss';
import VideoComponent from 'aplazame-design-system/src/components/VideoComponent';
import {
    Container,
    className,
    ImageComponent,
} from 'aplazame-design-system';

export default function BlockImageWithVideo({ image, backgroundColorScheme, video, toggleColumnOrder }) {
    backgroundColorScheme = backgroundColorScheme?.toLowerCase();
    const hasBackgroundColorScheme = backgroundColorScheme !== 'none' || backgroundColorScheme !== '';
    const [playVideo, setPlayVideo] = useState(false);
    const videoWrapperRef = useRef();
    useEffect(() => {
        if (
            typeof window !== 'undefined' &&
            video &&
            videoWrapperRef?.current
        ) {
            const onEndAnimation = () => {
                setPlayVideo(true);
            };

            window.addEventListener('sal:in', onEndAnimation);
            return () => {
                window.removeEventListener('sal:in', onEndAnimation);
            };
        }
    }, [videoWrapperRef, video, setPlayVideo]);


    const imageCmp = <div
        data-sal={`slide-up--lg-${toggleColumnOrder ? 'left' : 'right'
            }`}
    ><ImageComponent
            image={image}
            className={style.image}
        /></div>;

    const videoCmp = <div
        ref={videoWrapperRef}
        data-sal={`slide-up--lg-${toggleColumnOrder ? 'right' : 'left'
            }`}>
        <VideoComponent {...video} play={playVideo} />
    </div>;

    return (
        <section
            {...className(
                [
                    hasBackgroundColorScheme ? sectionStyle['with-bg'] : '',
                    hasBackgroundColorScheme
                        ? sectionStyle['with-bg--alt2']
                        : '',
                    hasBackgroundColorScheme
                        ? colorStyle[`with-bg--${backgroundColorScheme}`]
                        : '',
                ].join(' ')
            )}
        >
            {hasBackgroundColorScheme ? (
                <div
                    style={{ bottom: 0 }}
                    data-sal="fade"
                    data-sal-easing="ease-out-quart"
                    {...className(`${sectionStyle.bg} ${colorStyle.bg}`)}
                />
            ) : null}

            <Container pt={{ xs: 10, lg: 15 }} pb={{ xs: 10, lg: 15 }}>
                <div className={style.wrapper}>
                    <div className={toggleColumnOrder ? style.videoSwap : ''}>
                        {!toggleColumnOrder && imageCmp}
                        {toggleColumnOrder && videoCmp}
                    </div>
                    <div className={toggleColumnOrder ? style.imageSwap : ''}>
                        {!toggleColumnOrder && videoCmp}
                        {toggleColumnOrder && imageCmp}
                    </div>
                </div>
            </Container>
        </section>)
}

